// extracted by mini-css-extract-plugin
module.exports = {"pageTabs":"page-tabs-module--page-tabs--10H_a","pageNav":"page-tabs-module--page-nav--3SEik","pageTab":"page-tabs-module--page-tab--2i78j"};